export default "__VITE_ASSET__dVUtGFk4__"